import { useEffect, useState } from "react";
import { getStationBrand } from "./brands.js";
import { priceParts } from "./format.js";

const PATHS = {
  drop: "M12 3s6 6.4 6 11a6 6 0 0 1-12 0c0-4.6 6-11 6-11Zm-2.5 11.5A2.5 2.5 0 0 0 12 17",
  pin: "M12 21s7-5.2 7-12a7 7 0 1 0-14 0c0 6.8 7 12 7 12Zm0-9.5A2.5 2.5 0 1 1 12 6a2.5 2.5 0 0 1 0 5.5Z",
  locate: "M12 3v3m0 12v3M3 12h3m12 0h3m-9 5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z",
  search: "m20 20-4.2-4.2M17.5 11a6.5 6.5 0 1 1-13 0 6.5 6.5 0 0 1 13 0Z",
  nav: "M3 11 21 3l-8 18-2-8-8-2Z",
  camera: "M4 7h11v10H4zM15 10l5-3v10l-5-3",
  clock: "M12 7v5l3 2m6-2a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z",
  refresh: "M20 11a8 8 0 1 0-2.3 5.7M20 5v6h-6",
  moon: "M20 15.2A8 8 0 0 1 8.8 4 8.1 8.1 0 1 0 20 15.2Z",
  sun: "M12 4V2m0 20v-2M4 12H2m20 0h-2m-2.3-5.7 1.4-1.4M4.9 19.1l1.4-1.4m0-11.4L4.9 4.9m14.2 14.2-1.4-1.4M16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z",
  chevron: "m7 10 5 5 5-5",
  close: "M6 6l12 12M18 6 6 18",
  flag: "M5 21V4m0 0h11l-2 4 2 4H5",
  pump: "M4 21V5a2 2 0 0 1 2-2h6a2 2 0 0 1 2 2v16M3 21h12M7 8h4m3 2h2a2 2 0 0 1 2 2v4.5a1.5 1.5 0 0 0 3 0V8l-3-3",
  trip: "M5 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm14-8a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM7 16h5a3 3 0 0 0 3-3v0a3 3 0 0 1 3-3",
};

// Dos tipos de precio con identidad visual fija en toda la app:
// "trip" = precio con desplazamiento (cálculo de PetroPrize), "pump" = precio en surtidor.
export const PRICE_KINDS = {
  trip: { label: "con desplazamiento", short: "con viaje", icon: "trip" },
  pump: { label: "en surtidor", short: "surtidor", icon: "pump" },
};

export function Icon({ name }) {
  return (
    <svg className="icon" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9">
      <path d={PATHS[name]} strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export function Price({ value, unit = true, kind = "trip", className = "" }) {
  if (!Number.isFinite(value)) return null;
  const [main, last] = priceParts(value);
  return (
    <span className={`price is-${kind} ${className}`}>
      {main}<sup>{last}</sup>
      {unit && <span className="price-unit">€/L</span>}
    </span>
  );
}

export function PriceTag({ kind }) {
  return <span className={`price-tag is-${kind}`}><Icon name={PRICE_KINDS[kind].icon} />{PRICE_KINDS[kind].label}</span>;
}

export function PriceLegend() {
  return (
    <p className="price-legend" aria-label="Leyenda de precios">
      <PriceTag kind="trip" />
      <PriceTag kind="pump" />
    </p>
  );
}

export function BrandBadge({ station, brand: suppliedBrand }) {
  const brand = suppliedBrand || getStationBrand(station);
  if (!brand) return <span className="badge is-generic" aria-hidden="true"><Icon name="drop" /></span>;
  return (
    <span className={`badge brand-${brand.id}`} style={{ "--badge-bg": brand.color, "--badge-text": brand.text }} aria-hidden="true">
      {brand.mark}
    </span>
  );
}

export function useMediaQuery(query) {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const list = window.matchMedia(query);
    const update = () => setMatches(list.matches);
    update();
    list.addEventListener("change", update);
    return () => list.removeEventListener("change", update);
  }, [query]);
  return matches;
}

export function prefersReducedMotion() {
  return window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
